// extracted by mini-css-extract-plugin
export var attachmentContainer = "_my-0";
export var fileList = "_my-2";
export var removeFileButton = "_my-1";